<template>
  <div>
    <v-dialog
      max-width="600"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="btnColor"
          v-bind="attrs"
          v-on="on"
          :block="block"
          :x-large="xLarge"
        >
            <slot name="btn-contents" />
        </v-btn>
      </template>
      <template v-slot:default="dialog">
        <v-card>
          <v-card-text>
            <div class="pa-1">
              <slot name="contents" />
            </div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              text
              @click="dialog.value = false"
            ><v-icon color="grey">mdi-close-circle</v-icon>閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    btnColor: {
      type: String,
      default: ""
    },
    block: {
      type: Boolean,
      default: false
    },
    xLarge: {
      type: Boolean,
      default: false
    }
  }
};
</script>
